import { CertificateInfo } from "../store/pomeriumApi";

export function issuerName(
  certificateInfo: CertificateInfo | undefined,
): string {
  return certificateInfo?.issuer?.organization?.join(", ") || "";
}

export function subjectName(
  certificateInfo: CertificateInfo | undefined,
): string {
  return certificateInfo?.subject?.commonName || "";
}
